import { defineGameCard, afterAttack, drawCards, oncePerRound, roundMarkerStatus, } from '../authoring/index.js';
const COMBAT_DRAW_ROUND_KEY = '@cards/ability/reader_armchair/combat_draw/round';
export const ReaderArmchairCard = defineGameCard({
    id: 'reader_armchair',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 2, health: 5 } },
    presentation: {
        name: 'Кресло читателя',
        description: 'Первый раз за раунд, когда наносит боевой урон карте противника и остаётся на поле после атаки, возьмите 1 карту.',
        glyph: {
            colors: ['#10213A', '#AC613A', '#8E462F', '#763A29', '#EAAA64'],
            rows: [
                '....................',
                '....................',
                '......11111111......',
                '.....1223333221.....',
                '.....1333333331.....',
                '.....1331331331.....',
                '.....1333333331.....',
                '....113333333411....',
                '...12343333334221...',
                '...12314333341221...',
                '..1331111111111331..',
                '...13122255555131...',
                '...13125555522131...',
                '...13155522222131...',
                '...13311111111331...',
                '...13333333333331...',
                '....111111111111....',
                '....11........11....',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterAttack(oncePerRound({
            abilityId: 'combat_draw',
            trigger: 'onAttackResolved',
            when(ctx, event) {
                const self = ctx.self;
                if (self === undefined
                    || event.attackerId !== self.id
                    || event.amount <= 0
                    || event.target.kind !== 'unit')
                    return false;
                const liveSelf = ctx.q.allUnits().find((unit) => unit.id === self.id);
                const target = ctx.q.instance(event.target.instanceId);
                return liveSelf?.controllerId === self.controllerId
                    && target !== null
                    && target.controllerId !== self.controllerId;
            },
            run: drawCards(1),
        })),
    ],
    ui: {
        publicVars: {
            combatDrawRound: { key: COMBAT_DRAW_ROUND_KEY, kind: 'number' },
        },
        statusProviders: [roundMarkerStatus({
                fact: 'combatDrawRound',
                id: 'reader-armchair-used',
                symbol: '✓',
                label: 'Добор за бой',
                description: 'Кресло читателя уже принесло карту за бой в этом раунде.',
                tone: 'neutral',
            })],
    },
});
//# sourceMappingURL=reader_armchair.js.map